export default __webpack_public_path__ + "static/dot-pattern-olive-42228fbf342270a9656b289fe0362032.svg";